import { render, staticRenderFns } from "./EzTextarea.vue?vue&type=template&id=160feabe&scoped=true&"
import script from "./EzTextarea.vue?vue&type=script&lang=js&"
export * from "./EzTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EzTextarea.vue?vue&type=style&index=0&id=160feabe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160feabe",
  null
  
)

export default component.exports